import { GridColDef } from '@mui/x-data-grid-pro';
import { Field, Form, Formik, FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { RefObject } from 'react';
import { dataGridCol } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { IChargeBack } from '@modules/admin/AdminTools/PayPlan/interfaces';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';

const chargeBacksColumns: GridColDef[] = [
  dataGridCol('userName', { headerName: 'User' }),
  dataGridCol('positiveChargeBack', {
    editable: false,
    renderCell: (params) => <Field name={`[${params.row.index}].positiveChargeBack`} component={NumberInputField} prefix="$" />
  }),
  dataGridCol('negativeChargeBack', {
    editable: false,
    renderCell: (params) => <Field name={`[${params.row.index}].negativeChargeBack`} component={NumberInputField} prefix="$" />
  }),
].map(column => ({ minWidth: 300, flex: 1, ...column }));

interface IChargeBacksTableProps {
  formikRef: RefObject<FormikProps<IChargeBack[]>>;
  rows: (IChargeBack & { id: string })[];
  onSaveChanges: (values: IChargeBack[]) => void;
  onCancelChanges: () => void;
}

export const ChargeBacksTable = ({
  formikRef,
  rows,
  onSaveChanges,
  onCancelChanges
}: IChargeBacksTableProps) => {
  return (
    <Formik
      enableReinitialize
      innerRef={formikRef}
      initialValues={rows}
      onSubmit={onSaveChanges}
    >
      {formikProps => (
        <Form>
          <Grid container>
            <Grid item> 
              <SaveButton label="Save Changes" disabled={!formikProps.dirty} />
            </Grid>

            <Grid item>
              <CancelButton 
                label='Cancel Changes'
                disabled={!formikProps.dirty}
                onClick={onCancelChanges}
              />
            </Grid>
          </Grid>

          <PhoenixGrid
            canNotCopy
            noButton
            autoHeight
            pagination={false}
            isRowSelectable={() => false}
            columns={chargeBacksColumns}
            rows={rows}
            getRowId={row => row.userId}
          />
        </Form>
      )}
    </Formik>
  );
};